export const AppConfig = {
    apikey:"AIzaSyAMOoTT8MrZOl2QaJOYtXVuw_DA8ovDk0k"
  }